module.exports = __webpack_public_path__ + "pc/img/role.7e3aa697.png";